(() => {
  if (window.extroAnalyticsLoaded) return;
  window.extroAnalyticsLoaded = true;

  const sentScrollDepths = new Set();

  function consentGranted() {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return false;
    return privacy.analyticsProcessingAllowed();
  }

  function push(eventName, payload = {}) {
    if (!consentGranted()) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      extro_event: eventName,
      page_type: window.themeVariables?.settings?.pageType,
      ...payload
    });
  }

  function productPayload(variant) {
    const form = document.querySelector('form[action*="/cart/add"]');
    const id = variant?.id || form?.elements?.id?.value;
    return {
      product_id: window.meta?.product?.id,
      product_handle: window.location.pathname.split('/products/')[1]?.split(/[?#/]/)[0],
      variant_id: id || undefined,
      variant_title: variant?.title,
      price: variant?.price
    };
  }

  function setupProductEvents() {
    if (window.themeVariables?.settings?.pageType !== 'product') return;

    push('view_product', productPayload());

    document.addEventListener('variant:change', (event) => {
      push('variant_change', productPayload(event.detail?.variant));
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-gallery-step], [data-gallery-index], .product__thumbnail-item, .product__media-prev-next, .product__zoom-button')) {
        push('product_gallery_interaction', productPayload());
      }

      if (event.target.closest('[href="#guida-taglie"], #guida-taglie, .extro-size-help, [data-extro-size-help], .ep-fit, details summary')) {
        const text = event.target.closest('summary, a, button')?.textContent?.trim();
        if (text?.toLowerCase().includes('taglia') || event.target.closest('[href="#guida-taglie"], #guida-taglie, .extro-size-help, [data-extro-size-help]')) {
          push('open_size_guide', productPayload());
        }
      }
    }, true);
  }

  function setupCartEvents() {
    document.documentElement.addEventListener('cart:updated', (event) => {
      push('cart_updated', {
        item_count: event.detail?.cart?.item_count,
        total_price: event.detail?.cart?.total_price
      });
    });

    document.addEventListener('extro:cart-error', (event) => {
      push('cart_error', {
        message: event.detail?.message,
        line: event.detail?.line
      });
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-product-add-to-cart-button], .sticky-atc-button')) {
        push('add_to_cart_click', productPayload());
      }
    }, true);
  }

  function setupScrollDepth() {
    const marks = [25, 50, 75, 90];
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      if (max <= 0) return;
      const depth = Math.round((window.scrollY / max) * 100);
      for (const mark of marks) {
        if (depth >= mark && !sentScrollDepths.has(mark)) {
          sentScrollDepths.add(mark);
          push('scroll_depth', { percent: mark });
        }
      }
      if (sentScrollDepths.size === marks.length) window.removeEventListener('scroll', onScroll);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  setupProductEvents();
  setupCartEvents();
  setupScrollDepth();
})();
